import React from "react";
import { Outlet } from "react-router-dom";
const PropertyPurposeRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PropertyPurposeRoot;
